interface ThumbnailsProps {
  thumbnails?: string[];
}

export const Thumbnails = ({ thumbnails }: ThumbnailsProps) => {
  return (
    <div className="absolute bottom-0 left-0 right-0 top-0 flex h-full w-full overflow-hidden rounded-lg">
      {thumbnails?.[0] && (
        <img
          key={-1}
          src={thumbnails[0]}
          alt=""
          className="h-full min-w-0 flex-1 object-cover"
        />
      )}
      {thumbnails?.map((thumbnail, i) => (
        <img
          key={i}
          src={thumbnail}
          alt=""
          className="h-full min-w-0 flex-1 object-cover"
        />
      ))}
      {thumbnails?.at(-1) && (
        <img
          key={thumbnails.length + 1}
          src={thumbnails?.at(-1)}
          alt=""
          className="h-full min-w-0 flex-1 object-cover"
        />
      )}
    </div>
  );
};
